import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _ArrowIosUp;
import { useState } from "react";
import cn from "clsx";
import { Collapse } from "@crehana/compass.ui";
import ArrowIosUp from "@crehana/icons/outline/ArrowIosUp";
import ActionButton from "./ActionButton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ActionMetrics = function ActionMetrics(_ref) {
  var title = _ref.title,
    isDark = _ref.isDark,
    metrics = _ref.metrics,
    className = _ref.className;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    className: cn('tw-w-full dark:tw-text-neutral-light-100', className),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cn('tw-flex tw-justify-between tw-items-center tw-transition-all', isOpen ? 'tw-mb-1.6' : 'tw-mb-0'),
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-font-subtitle3",
        children: title
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        className: "tw-flex-shrink-0 tw-block lg:tw-hidden tw-transition-transform tw-w-2.4 tw-h-2.4",
        style: {
          transform: isOpen ? 'rotate(0deg)' : 'rotate(180deg)'
        },
        onClick: function onClick() {
          return setIsOpen(function (prev) {
            return !prev;
          });
        },
        children: _ArrowIosUp || (_ArrowIosUp = /*#__PURE__*/_jsx(ArrowIosUp, {
          size: 24,
          className: "tw-fill-current"
        }))
      })]
    }), /*#__PURE__*/_jsx(Collapse, {
      open: isOpen,
      children: /*#__PURE__*/_jsx("div", {
        "data-testid": "action-metrics-content",
        className: "tw-grid tw-grid-cols-2 md:tw-grid-cols-4 tw-gap-1.6",
        children: metrics.map(function (metric) {
          return /*#__PURE__*/_jsx(ActionButton, {
            isDark: isDark,
            metric: metric,
            className: "md:tw-mb-0.4"
          }, metric.description);
        })
      })
    })]
  });
};
export default ActionMetrics;